import React from 'react';
import styled from 'styled-components';
import { GrClose } from 'react-icons/gr';
import { VisuallyLogo } from '@/features/strapi/components/logo';

export interface MobileMenuOverlayProps {
  header?: any;
  children?: any;
  onBackdropClicked?: () => void;
  onClose?: () => void;
}

export function MobileMenuOverlay({
  header,
  children,
  onBackdropClicked,
  onClose,
}: MobileMenuOverlayProps) {
  return (
    <MenuBackdrop onClick={onBackdropClicked || onClose}>
      <Menu onClick={(ev) => ev.stopPropagation()}>
        <div className="header">
          {header || <VisuallyLogo wide />}
          <GrClose className="close" size={25} onClick={onClose} />
        </div>
        <div className="list">{children}</div>
      </Menu>
    </MenuBackdrop>
  );
}

const MenuBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
  z-index: 999999999 !important;
`;

const Menu = styled.div`
  position: relative;
  padding: 3rem 3rem;
  background: white;

  .close {
    position: absolute;
    top: 3rem;
    right: 2.5rem;
  }

  .header {
    margin-bottom: 5rem;
  }

  .list {
    display: grid;
    grid-template-columns: max-content;
    grid-gap: 3rem;

    a {
      text-align: start;
      font-size: 2rem;
    }

    .btn {
      margin-top: 1rem;
      font-size: 2rem;
    }
  }

  transform-origin: center 0;

  @keyframes reveal {
    0% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  animation: reveal 0.5s ease-in-out;
`;
